<template>
    <div>
        <ListTopButton
            :tabs="tabs"
            v-model:activeTab="activeTab"
            v-model:activeComponent="activeComponent"
        />
        <component
            :is="activeComponent"
            v-if="activeTab"
            :currentTab="activeTab"
        />
    </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import { onMounted, ref, watch} from "vue";
import ListTopButton from '@/components/molecule/company/dental-os/appointment/ListTopButton.vue';
import { shallowRef } from 'vue';
import Appointment from '@/components/molecule/company/dental-os/appointment/tab/Appointment.vue';
import OngoingService from '@/components/molecule/company/dental-os/appointment/tab/OngoingService.vue';
import CompletedService from '@/components/molecule/company/dental-os/appointment/tab/CompletedService.vue';

const route = useRoute();
const router = useRouter();

const activeTab = ref('appointment_list');
const activeComponent = shallowRef(Appointment);

const tabs = shallowRef([
    { slug: 'appointment_list', buttonType: 'primary', title: 'Appointment', component: Appointment },
    { slug: 'ongoing_service', buttonType: 'warning', title: 'Ongoing Service', component: OngoingService },
    { slug: 'completed_service', buttonType: 'success', title: 'Completed Service', component: CompletedService },
]);

const setCurrentTab = () => {
    let hashPath = route.hash.substring(1) || tabs.value[0].slug;
    activeTab.value = hashPath;

    const tab = tabs.value.find(item => item.slug === hashPath);
    activeComponent.value = tab.component;
}

onMounted(() => {
    setCurrentTab();
})
</script>


